import { fetchPaymentSources } from '../../actions'

export function submitVerifyPaymentSource(handleClose) {
  return (dispatch, getState) => {
    const { verifyPaymentSourceForm, organization, resident } = getState()
    const { id, amount1, amount2 } = verifyPaymentSourceForm

    dispatch({type:'BEGIN_SUBMIT_VERIFY_PAYMENT_SOURCE'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/${id}/verify.json`,
      method: 'patch',
      data: {
        payment_source : {
          amount1,
          amount2,
        }
      },
      success: () => { 
        dispatch(fetchPaymentSources())
        handleClose() 
      },
      error: xhr => {
        var errors = $.parseJSON(xhr.responseText).errors
        dispatch({ type:'FAILED_SUBMIT_VERIFY_PAYMENT_SOURCE', payload: errors })
      }
    })
  }
}